import { FormattedMessage } from 'react-intl';
import messages from '../../../i18n/base-en.js';
import { closeModalAnimation } from '../../Modal/modal-actions/modal-actions';
import useClickOutside from '../../reusables/colorpicker/useClickOutside';
import { BigIcon } from '../../reusables';

const OfferRequestSentModal = ({ dispatch, modalInner }) => {
  const closeOpenModal = () => {
    dispatch(closeModalAnimation());
  };

  useClickOutside(modalInner, closeOpenModal);

  return (
    <div id="offer-requested-modal">
      <div className="modal-content">
        <span className="modal-action modal-close hov-primary-color" onClick={closeOpenModal}>
          <i className="material-icons">close</i>
        </span>
      </div>
      <div>
        <BigIcon className="z-depth-2 big-icon" icon="thumb_up" />
        <div className="title">
          <FormattedMessage {...messages.offerRequestSent} />
          <hr className="bg-primary-color" />
        </div>
        <div className="offerRequestModalTextDiv">
          <FormattedMessage className="offerRequestModalText" {...messages.genericTextApplyOfferReturn} />
        </div>
      </div>
    </div>
  );
};

export default OfferRequestSentModal;
